var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecentralizedstack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 67,
    viewBox: "0 0 84 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3408_8495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6639 5.59863V61.4013L78.3947 33.4956L20.6639 5.59863Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.336 61.4013V5.59863L5.60522 33.4956L63.336 61.4013Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.336 5.59863L78.3947 33.4956L63.336 61.4013H20.6639L5.60522 33.4956L20.6639 5.59863H63.336Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60522 33.4956H78.3947",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9956 15.9624V51.0376",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3361 66.1225C65.9466 66.1225 68.0628 64.0088 68.0628 61.4013C68.0628 58.7939 65.9466 56.6802 63.3361 56.6802C60.7256 56.6802 58.6094 58.7939 58.6094 61.4013C58.6094 64.0088 60.7256 66.1225 63.3361 66.1225Z",
    fill: "url(#paint0_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6639 9.84601C23.0124 9.84601 24.9162 7.94443 24.9162 5.59872C24.9162 3.25301 23.0124 1.35144 20.6639 1.35144C18.3154 1.35144 16.4116 3.25301 16.4116 5.59872C16.4116 7.94443 18.3154 9.84601 20.6639 9.84601Z",
    fill: "url(#paint1_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3361 66.1225C65.9466 66.1225 68.0628 64.0088 68.0628 61.4013C68.0628 58.7939 65.9466 56.6802 63.3361 56.6802C60.7256 56.6802 58.6094 58.7939 58.6094 61.4013C58.6094 64.0088 60.7256 66.1225 63.3361 66.1225Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6639 9.84601C23.0124 9.84601 24.9162 7.94443 24.9162 5.59872C24.9162 3.25301 23.0124 1.35144 20.6639 1.35144C18.3154 1.35144 16.4116 3.25301 16.4116 5.59872C16.4116 7.94443 18.3154 9.84601 20.6639 9.84601Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3361 10.3199C65.9466 10.3199 68.0628 8.20614 68.0628 5.59872C68.0628 2.9913 65.9466 0.877563 63.3361 0.877563C60.7256 0.877563 58.6094 2.9913 58.6094 5.59872C58.6094 8.20614 60.7256 10.3199 63.3361 10.3199Z",
    fill: "url(#paint2_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3361 10.3199C65.9466 10.3199 68.0628 8.20614 68.0628 5.59872C68.0628 2.9913 65.9466 0.877563 63.3361 0.877563C60.7256 0.877563 58.6094 2.9913 58.6094 5.59872C58.6094 8.20614 60.7256 10.3199 63.3361 10.3199Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.664 66.1225C23.2744 66.1225 25.3907 64.0088 25.3907 61.4013C25.3907 58.7939 23.2744 56.6802 20.664 56.6802C18.0535 56.6802 15.9373 58.7939 15.9373 61.4013C15.9373 64.0088 18.0535 66.1225 20.664 66.1225Z",
    fill: "url(#paint3_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.664 66.1225C23.2744 66.1225 25.3907 64.0088 25.3907 61.4013C25.3907 58.7939 23.2744 56.6802 20.664 56.6802C18.0535 56.6802 15.9373 58.7939 15.9373 61.4013C15.9373 64.0088 18.0535 66.1225 20.664 66.1225Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3947 38.2167C81.0052 38.2167 83.1214 36.103 83.1214 33.4956C83.1214 30.8881 81.0052 28.7744 78.3947 28.7744C75.7842 28.7744 73.668 30.8881 73.668 33.4956C73.668 36.103 75.7842 38.2167 78.3947 38.2167Z",
    fill: "url(#paint4_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60524 38.2167C8.21573 38.2167 10.3319 36.103 10.3319 33.4956C10.3319 30.8881 8.21573 28.7744 5.60524 28.7744C2.99476 28.7744 0.87854 30.8881 0.87854 33.4956C0.87854 36.103 2.99476 38.2167 5.60524 38.2167Z",
    fill: "url(#paint5_linear_3408_8495)",
    stroke: "#2A2A39",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3947 38.2167C81.0052 38.2167 83.1214 36.103 83.1214 33.4956C83.1214 30.8881 81.0052 28.7744 78.3947 28.7744C75.7842 28.7744 73.668 30.8881 73.668 33.4956C73.668 36.103 75.7842 38.2167 78.3947 38.2167Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60524 38.2167C8.21573 38.2167 10.3319 36.103 10.3319 33.4956C10.3319 30.8881 8.21573 28.7744 5.60524 28.7744C2.99476 28.7744 0.87854 30.8881 0.87854 33.4956C0.87854 36.103 2.99476 38.2167 5.60524 38.2167Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3408_8495",
    x1: 58.6094,
    y1: 61.4013,
    x2: 68.0628,
    y2: 61.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3408_8495",
    x1: 16.4116,
    y1: 5.59872,
    x2: 24.9162,
    y2: 5.59872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3408_8495",
    x1: 58.6094,
    y1: 5.59872,
    x2: 68.0628,
    y2: 5.59872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3408_8495",
    x1: 15.9373,
    y1: 61.4013,
    x2: 25.3907,
    y2: 61.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3408_8495",
    x1: 73.668,
    y1: 33.4956,
    x2: 83.1214,
    y2: 33.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3408_8495",
    x1: 0.87854,
    y1: 33.4956,
    x2: 10.3319,
    y2: 33.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF94A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#E03DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3408_8495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentralizedstack);
export default __webpack_public_path__ + "static/media/decentralizedstack.6cf985a9bfc336e08855830b008ae4a4.svg";
export { ForwardRef as ReactComponent };